import {
  Avatar,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import React, { createRef } from "react";
import { colors } from "../../theme/colors";
import { useNavigate } from "react-router-dom";
import { createFileName, useScreenshot } from "use-react-screenshot";

export default function Result({ product, beneficiarie, va, result }) {
  const navigate = useNavigate();
  const wrapperRef = createRef(null);
  const [img, takeScreenShot] = useScreenshot({
    type: "image/jpeg",
    quality: 1.0,
  });

  const download = (
    image,
    {
      name = `EbiOky-${product.voucherName}-${
        new Date().toISOString().split("T")[0]
      }`,
      extension = "jpg",
    } = {}
  ) => {
    const a = document.createElement("a");
    a.href = image;
    a.download = createFileName(extension, name);
    a.click();
  };

  const downloadScreenShot = () =>
    takeScreenShot(wrapperRef.current).then(download);

  return (
    <Box
      sx={{
        minHeight: {
          xs: "70dvh",
          md: "auto",
        },
        backgroundColor: colors.white.main,
        paddingY: "4rem",
        paddingX: {
          xs: "4rem",
          md: "0rem",
        },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        <Grid item xs={12} md={10} lg={8}>
          <Box sx={{ textAlign: "center" }}>
            <Typography
              variant="h1"
              component="h2"
              sx={{
                color: "#00216A",
                fontWeight: "bold",
                marginBottom: "16px",
                fontSize: "40px",
              }}
            >
              ¡Muchas gracias por tu generosa donación!
            </Typography>

            <Typography
              variant="h6"
              component="h3"
              sx={{
                fontWeight: "bold",
                marginBottom: "16px",
                color: colors.white.main,
                fontSize: "24px",
              }}
            >
              Vuelos hacia la educación
            </Typography>

            <Typography
              variant="body1"
              sx={{
                marginBottom: "20px",
                lineHeight: "22px",
                maxWidth: "800px",
                fontSize: "16px",
                color: "#3F4141",
                margin: "0 auto 20px auto",
              }}
            >
              Tu apoyo significa mucho para nosotros y hará una gran diferencia
              en nuestros esfuerzos. Apreciamos sinceramente tu amabilidad y
              compromiso con nuestra causa.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
